import { render } from "./message-emoji-react.vue?vue&type=template&id=3c9d6455&scoped=true&ts=true"
import script from "./message-emoji-react.vue?vue&type=script&lang=ts"
export * from "./message-emoji-react.vue?vue&type=script&lang=ts"

import "./message-emoji-react.vue?vue&type=style&index=0&id=3c9d6455&lang=scss&scoped=true"

import exportComponent from "D:\\chat-tx\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9d6455"]])

export default __exports__